
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../Assets/Css/fabrication.css';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { FaCheckCircle } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

import aboutfabricationservice from '../Assets/Image/aboutfabrication.avif';
import manpowerhousecta from '../Assets/Image/ctafabricationimg.avif';

import fabrication1 from '../Assets/Image/steelfab.avif';
import fabrication3 from '../Assets/Image/sheetmetalfab.avif';
import fabrication4 from '../Assets/Image/Custom Equipment fab.avif';
import fabrication5 from '../Assets/Image/Industrial Shed Fabrication.avif';
import fabrication7 from '../Assets/Image/Tank and Vessel Fabrication.avif';
import fabrication8 from '../Assets/Image/Handrails and Staircase Fabrication.avif';
import fabrication9 from '../Assets/Image/ducting and Ventilation Fabrication.avif';
import fabrication10 from '../Assets/Image/machineryplatformgab.avif';

export default function FabricationServices() {
 const fabricationServices = [
  {
    title: "Structural Steel Fabrication",
    image: fabrication1,
  },
 
  {
    title: "Sheet Metal Fabrication",
    image: fabrication3,
  },
  {
    title: "Custom Equipment Frames",
    image: fabrication4,
  },
  {
    title: "Industrial Shed Fabrication",
    image: fabrication5,
  },
  
  {
    title: "Tank & Vessel Fabrication",
    image: fabrication7,
  },
  {
    title: "Handrails & Staircase Fabrication",
    image: fabrication8,
  },
  {
    title: "Ducting & Ventilation Fabrication",
    image: fabrication9,
  },
  {
    title: "Machinery Base & Platform Fabrication",
    image: fabrication10,
  },
];


  const testimonials = [
    {
      message: "Their steel structure expertise helped us complete our industrial facility ahead of schedule.",
      author: "Project Engineer",
    },
    {
      message: "Professional team, accurate fabrication, and flawless erection. Highly recommended.",
      author: "Structural Consultant",
    },
    {
      message: "Our warehouse structure was installed with precision and safety top of mind.",
      author: "Site Manager",
    },
  ];

  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        {/* Basic SEO */}
        <title>Industrial & Commercial Fabrication Services | Pradh</title>
        <meta
          name="description"
          content="Pradh offers expert fabrication services including structural steel, sheet metal, tanks, ducts, platforms, and custom frames. Precision-built for industrial and commercial projects."
        />
        <meta
          name="keywords"
          content="Fabrication Services, Structural Steel Fabrication, Sheet Metal Fabrication, Industrial Shed Fabrication, Custom Frames, Tank Fabrication, Industrial Ducting, Metal Work India"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Industrial & Commercial Fabrication Services | Pradh" />
        <meta
          property="og:description"
          content="From structural frameworks to ducting and industrial platforms, Pradh delivers reliable, high-quality fabrication services across sectors."
        />
        <meta property="og:url" content="https://pradh.com/fabrication-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/fabrication-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Industrial & Commercial Fabrication Services | Pradh" />
        <meta
          name="twitter:description"
          content="Expert fabrication solutions for sheds, tanks, staircases, equipment bases, and structural steel. Delivered with quality and safety."
        />
        <meta name="twitter:image" content="https://pradh.com/images/fabrication-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/fabrication-services" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section8">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Fabrication Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">All Kinds of Industrial & Commercial Fabrication Solutions</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">
            Get in Touch
          </a>
        </div>
      </section>

      {/* Overview Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={5} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutfabricationservice}
                alt="fabrication services"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={7}>
              <h2 className="page-title text-center mb-3" data-aos="fade-up">Overview</h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong> offers end-to-end fabrication services, delivering precision, durability, and performance for industrial, commercial, and infrastructure needs.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                Our team of skilled welders, fabricators, and project engineers ensures flawless execution—from structural steelwork to custom fabrication. We adhere to the highest safety and quality standards for every project.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Fabrication Services Listing */}
   

<section className="services-list-section py-4 bg-light">
  <Container>
    <h2 className="page-title text-center mb-4" data-aos="fade-up">Our Fabrication Services</h2>
    <Row>
      {fabricationServices.map((service, index) => (
        <Col key={index} md={6} lg={3} className="mb-4" data-aos="zoom-in" data-aos-delay="100">
          <Card className="fabservice-card h-100 shadow-sm border-0">
            <div className="fabservice-img-wrapper">
              <Card.Img
                variant="top"
                src={service.image}
                alt={service.title}
              />
            </div>
            <Card.Body className="text-center">
              <h6 className="fabservice-title">{service.title}</h6>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
</section>

{/* How It Works & Applications Section */}
<section className="fab-process-application py-5 bg-light">
  <Container>
    <h2 className="page-title text-center mb-5" data-aos="fade-up">
     Working & Applications
    </h2>

    <Row className="justify-content-center">
      <Col md={10}>
        <div className="process-box mb-5" data-aos="fade-up" data-aos-delay="100">
          <h5 className="fw-bold mb-3 text-gradient"> How We Work</h5>
          <p className="process-text">
            Our fabrication services follow a streamlined process to ensure <strong>accuracy</strong>, <strong>durability</strong>, and <strong>project success</strong>. We begin with a client consultation, then proceed to CAD planning, precision cutting & welding, and surface finishing. Every structure is quality-tested and installed with safety and longevity in mind.
          </p>
       

       
          <h5 className="fw-bold mb-4 text-gradient"> Application Areas</h5>
          <ul className="application-list">
            <li><FaCheckCircle className="icon-success me-2" /> Industrial Warehouses & Sheds</li>
            <li><FaCheckCircle className="icon-success me-2" /> Power Plants & Process Industries</li>
            <li><FaCheckCircle className="icon-success me-2" /> Commercial Buildings & Malls</li>
            <li><FaCheckCircle className="icon-success me-2" /> Manufacturing Equipment Frameworks</li>
            <li><FaCheckCircle className="icon-success me-2" /> Railways, Airports & Infrastructure Projects</li>
          </ul>
        </div>
      </Col>
    </Row>
  </Container>
</section>






      {/* CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={7} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Looking for reliable fabrication experts?</h2>
              <p className="lead">
                From design to delivery, our team ensures strength, precision, and on-time project completion.
              </p>
              <a href="/contact" className="btn-get">Get in Touch</a>
            </Col>
            <Col md={5}>
              <div className="d-flex justify-content-center">
                <img
                  src={manpowerhousecta}
                  alt="Fabrication CTA"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
